import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DocumentState {
    scroll: number,
    isEditable: boolean,
    nbPaste
}


const initialState: DocumentState = {
    scroll: 0,
    isEditable: true,
    nbPaste: 0
}

const documentSlice = createSlice({
    name: 'document',
    initialState,
    reducers: {
        documentSetScroll: (state, action: PayloadAction<number>) => {
            state.scroll = action.payload;
        },
        documentSetEditable: (state, action: PayloadAction<boolean>) => {
            state.isEditable = action.payload;
        },
        documentSetPaste(state, action: PayloadAction<number>) {
            state.nbPaste = action.payload;

        },
        documentIncrementPaste(state) {
            state.nbPaste = state.nbPaste + 1;
        }
    }
})

export const { documentSetScroll, documentSetEditable, documentSetPaste, documentIncrementPaste } = documentSlice.actions;

export default documentSlice.reducer;